import { Checkbox } from "@babackapp/ui/components/checkbox";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@babackapp/ui/components/sidebar";
import { ChevronsUpDown, LayoutGrid } from "lucide-react";
import { ADMIN_MODULES, type AdminModule } from "./admin-preferences";

/** Picks the modules whose pages the menu shows (several at once). */
export function AdminModuleFilter({
  modules,
  onChange,
}: {
  modules: AdminModule[];
  onChange: (next: AdminModule[]) => void;
}) {
  const summary =
    modules.length === ADMIN_MODULES.length
      ? "Tous les modules"
      : modules.length === 0
        ? "Aucun module"
        : ADMIN_MODULES.filter(({ value }) => modules.includes(value))
            .map(({ label }) => label)
            .join(", ");

  function toggle(module: AdminModule, isChecked: boolean) {
    onChange(
      isChecked
        ? ADMIN_MODULES.map(({ value }) => value).filter(
            (value) => value === module || modules.includes(value),
          )
        : modules.filter((value) => value !== module),
    );
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <Popover>
          <PopoverTrigger asChild>
            <SidebarMenuButton
              tooltip={`Modules : ${summary}`}
              className="data-[state=open]:bg-sidebar-accent"
            >
              <LayoutGrid />
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate text-xs text-sidebar-foreground/75">
                  Modules
                </span>
                <span className="truncate font-medium">{summary}</span>
              </div>
              <ChevronsUpDown className="ml-auto" />
            </SidebarMenuButton>
          </PopoverTrigger>
          <PopoverContent className="w-60 p-2" align="start" side="bottom">
            <div className="space-y-1">
              {ADMIN_MODULES.map(({ value, label }) => (
                <label
                  key={value}
                  className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-muted"
                >
                  <Checkbox
                    checked={modules.includes(value)}
                    onCheckedChange={(checked) =>
                      toggle(value, checked === true)
                    }
                  />
                  {label}
                </label>
              ))}
            </div>
            <p className="mt-2 border-t px-2 pt-2 text-xs text-muted-foreground">
              Vue d'ensemble toujours affichée. Choix gardé dans ce navigateur.
            </p>
          </PopoverContent>
        </Popover>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
